export interface PasswordStrengthResult {
  valid: boolean;
  errors: string[];
}

const WEAK_PASSWORDS = [
  'password',
  'Password1',
  'Admin123',
  'Welcome123',
  'ChangeMe123',
  'Password123',
  'Admin@123',
  'Welcome@123',
  'Test1234',
  'Qwerty123',
];

export const validatePasswordStrength = (password: string): PasswordStrengthResult => {
  const errors: string[] = [];

  if (password.length < 8) {
    errors.push('Password must be at least 8 characters long');
  }

  if (password.length > 128) {
    errors.push('Password must not exceed 128 characters');
  }

  if (!/[A-Z]/.test(password)) {
    errors.push('Password must contain at least one uppercase letter');
  }

  if (!/[a-z]/.test(password)) {
    errors.push('Password must contain at least one lowercase letter');
  }

  if (!/[0-9]/.test(password)) {
    errors.push('Password must contain at least one number');
  }

  if (!/[^A-Za-z0-9]/.test(password)) {
    errors.push('Password must contain at least one special character');
  }

  if (WEAK_PASSWORDS.some(weak => password.toLowerCase().includes(weak.toLowerCase()))) {
    errors.push('Password is too common or weak');
  }

  return {
    valid: errors.length === 0,
    errors,
  };
};
